export enum FilterType {
  Category = 'categories',
  Status = 'statuses',
  AreasOfInterest = 'areasOfInterest',
  Team = 'teams',
  Assignee = 'assignees',
  Street = 'street',
  Tag = 'tags',
  ExternalRequest = 'isExternalRequest',
}
